import { render, staticRenderFns } from "./CostPricesInstructionsDetail.vue?vue&type=template&id=31697b24&scoped=true"
import script from "./CostPricesInstructionsDetail.vue?vue&type=script&lang=js"
export * from "./CostPricesInstructionsDetail.vue?vue&type=script&lang=js"
import style0 from "./CostPricesInstructionsDetail.vue?vue&type=style&index=0&id=31697b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31697b24",
  null
  
)

export default component.exports